<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="app-container">
    <Header
      @handleLoginSelection="handleLoginSelection"
      @handleSignUpSelection="handleSignUpSelection"
    />

    <div class="title-container">
      <!-- <img src="@/assets/temple_hero.jpg" alt="Temple Hero" class="banner" /> -->
      <video
        src="@/assets/temple.mp4"
        autoplay
        muted
        loop
        class="banner"
      ></video>
      <div class="overlay-container">
        <Vue-feather type="sunrise" size="32"></Vue-feather>
        <h1 class="overlay-title">Live Drone Darshan</h1>
        <h3 class="overlay-subheading">connecting hearts to holy places</h3>
        <div class="overlay-time-container">
          <vue-feather type="clock" size="16"></vue-feather>
          <p class="overlay-time">{{ currentTime }}</p>
        </div>
        <div class="overlay-description-container">
          <hr class="line-divider-light" />
          <br />
          <p class="overlay-description">
            Join live drone darshans of India's sacred sites—see the temple, the
            setting, and the story in real time.
          </p>
        </div>
        <button class="overlay-button" @click="scrollToBookDarshan">
          Fly with us
        </button>
      </div>
    </div>

    <!-- Blog Content -->
    <div :class="mainContentClass">
      <div class="title-container">
        <h1 class="main-title">Why Live Drone Darshan?</h1>
      </div>
      <p class="main-subheading">
        Live drone darshan offers a unique and sacred way to connect with
        temples.
      </p>
      <br />

      <div class="vision-cards why-drone-section">
        <div class="vision-card">
          <h3>Can't Always Travel</h3>
          <p>
            Distance, crowds, age, and time make many pilgrimages hard. Live
            darshan brings the temple to you.
          </p>
        </div>
        <div class="vision-card">
          <h3>Stay Close to Tradition</h3>
          <p>
            Join aarti, festivals, and seasonal rituals—even when you're
            overseas.
          </p>
        </div>
        <div class="vision-card">
          <h3>Share the Blessing</h3>
          <p>
            Watch together across time zones; receive a digital prasad or
            blessing note.
          </p>
        </div>
        <div class="vision-card">
          <h3>Accessible</h3>
          <p>Join darshan from anywhere—no travel, no barriers.</p>
        </div>
        <div class="vision-card">
          <h3>Aerial</h3>
          <p>See the temple’s beauty and setting from above.</p>
        </div>
        <div class="vision-card">
          <h3>Connected</h3>
          <p>Share the moment live with family and friends.</p>
        </div>
      </div>

      <div class="title-container">
        <h1 class="main-title">Bringing Holy Places to Devotees Home</h1>
      </div>
      <p class="main-subheading">
        Experience live temple views, aarti moments, and sacred
        architecture—without the travel, crowds, or distance.
      </p>
      <br />

      <div class="vision-cards why-drone-section">
        <div class="vision-card">
          <vue-feather type="eye" size="18" style="color: black"></vue-feather>
          <h3>See the Temple</h3>
          <p>View sanctums, courtyards, and surroundings in real time.</p>
        </div>

        <div class="vision-card">
          <vue-feather
            type="users"
            size="18"
            style="color: black"
          ></vue-feather>
          <h3>Join the Moment</h3>
          <p>
            Watch aarti or festivals live; chat questions to the guide host.
          </p>
        </div>

        <div class="vision-card">
          <vue-feather
            type="book-open"
            size="18"
            style="color: black"
          ></vue-feather>
          <h3>Learn the Story</h3>
          <p>Hear the history, legends, and why the site is sacred.</p>
        </div>
      </div>

      <div>
        <img src="@/assets/flightportal.jpg" class="flightportal" />
      </div>

      <!-- <div>
        <img src="@/assets/livestream_flight.png" class="flightportal" />
      </div> -->

      <!-- <div class="benefits-container">
        <div class="title-container">
          <h1 class="main-title">Why Live Drone Darshan Works for Devotees</h1>
        </div>
        <br />
        <br />
        <br />
        <div class="benefit-cards">
          <div class="vision-card">
            <div class="benefit-icon">🙏</div>
            <h3>Accessible</h3>
            <p>
              Elderly, busy families, and NRIs can participate from anywhere.
            </p>
            <router-link to="/blog/accessible-darshan" class="learn-more-link">
              Learn More
              <vue-feather type="arrow-right" size="14"></vue-feather>
            </router-link>
          </div>
          <div class="vision-card">
            <div class="benefit-icon">🚁</div>
            <h3>Aerial</h3>
            <p>
              See the temple's architecture, setting, and scale—what you miss
              from ground level.
            </p>
            <router-link to="/blog/aerial-temple-views" class="learn-more-link">
              Learn More
              <vue-feather type="arrow-right" size="14"></vue-feather>
            </router-link>
          </div>
          <div class="vision-card">
            <div class="benefit-icon">💫</div>
            <h3>Connected</h3>
            <p>
              Share the darshan live with family in different cities and
              countries.
            </p>
            <router-link to="/blog/connected-devotion" class="learn-more-link">
              Learn More
              <vue-feather type="arrow-right" size="14"></vue-feather>
            </router-link>
          </div>
        </div>
      </div> -->

      <div class="title-container">
        <h1 class="main-title">Choose From Our Stunning Locations</h1>
      </div>
      <p class="main-subheading">
        Book a live drone darshan or festival stream from India's most revered
        temples.
      </p>

      <div>
        <div class="grid-container" id="temple-flights">
          <div
            class="grid-item"
            :class="{ disabled: !temple.isActive }"
            v-for="temple in templeFlights"
            :key="temple.id"
            @click="navigateToListing(temple.id)"
          >
            <div class="flight-content">
              <div class="image-container">
                <img
                  :src="
                    temple.bannerUrl ||
                    require(`@/assets/placeholder-image-listing.png`)
                  "
                  alt="Temple Image"
                  class="flight-image"
                />
              </div>
              <div class="flight-details">
                <div class="flight-header">
                  <h4>{{ getTruncatedDescription(temple.location, 35) }}</h4>
                  <h2>{{ temple.title }}</h2>
                  <br />
                  <hr class="line-divider" />
                </div>

                <div class="flight-info">
                  <p>{{ getTruncatedDescription(temple.description, 200) }}</p>
                  <hr class="line-divider" />
                </div>

                <div class="flight-footer">
                  <div class="price-container">
                    <span>30 min · Live Drone Darshan</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="title-container">
        <h1 class="main-title">How it works</h1>
      </div>

      <StepperComponent :steps="stepsData" />

      <!-- <ReviewsSection :reviews="reviewsData" /> -->

      <ContactForm
        id="contact-form"
        :formData="formData"
        :submitForm="submitForm"
        showBanner
        subheading="Get in touch with us to learn more about our drone darshan"
      />

      <Footer />
    </div>

    <SignUpModal
      :isOpen="isSignUpModalOpen"
      @close="closeSignUpModal"
      :onSubmit="handleSignUp"
      @openLoginModal="openLoginModal"
      :errorMessage="errorMessage"
    />

    <LoginModal
      :isOpen="isLoginModalOpen"
      @close="closeLoginModal"
      @openSignUpModal="openSignUpModal"
      :onSubmit="handleLoginButton"
      :errorMessage="errorMessage"
    />
  </div>
</template>

<script>
import { auth } from "@/plugins/firebase";
import { signOut } from "firebase/auth";
import { useSessionStore } from "../stores/session.js";
import { isMobile } from "@/utils/helper";
import { computed } from "vue";
import { amplitude } from "../plugins/amplitude.js";
import { loginService, userAuth } from "../services/userAuth";
import Header from "@/components/organisms/Header.vue";
import { truncateText } from "@/utils/helper";
import Footer from "@/components/Footer.vue";
import {
  addDoc,
  collection,
  getFirestore,
  onSnapshot,
  orderBy,
  query,
} from "firebase/firestore";
import ContactForm from "@/components/organisms/ContactForm.vue";
import StepperComponent from "@/components/organisms/Stepper.vue";
import SignUpModal from "@/components/organisms/modal/signUpModal.vue";
import LoginModal from "../components/organisms/modal/loginModal.vue";

export default {
  name: "TemplesView",
  components: {
    Header,
    Footer,
    StepperComponent,
    ContactForm,
    SignUpModal,
    LoginModal,
  },
  data() {
    return {
      stepsData: [
        {
          icon: "home", // Icon type for "Pick a Temple"
          title: "Pick a Temple",
          description:
            "Choose from India's most sacred sites and pilgrimage destinations.",
        },
        {
          icon: "calendar", // Icon type for "Choose Date / Aarti"
          title: "Book Date / Aarti",
          description:
            "Select live darshan time or special festival broadcast.",
        },
        {
          icon: "play-circle", // Icon type for "Join Live Stream"
          title: "Join Live Stream",
          description: "Watch the live drone feed and connect with devotees.",
        },
      ],
      reviewsData: [
        {
          name: "Priya S.",
          comment:
            "Being able to join aarti from our home in Canada was such a blessing. The aerial views showed us the temple in ways we'd never seen before.",
          avatar: require("@/assets/mount-fuji.jpg"),
        },
        {
          name: "Raj P.",
          comment:
            "My elderly mother could finally visit the temple she's dreamed of seeing. The live darshan brought tears of joy to her eyes.",
          avatar: require("@/assets/whale.jpg"),
        },
        {
          name: "Anita K.",
          comment:
            "Our family in three different countries watched the Diwali celebration together. It felt like we were all there in the temple courtyard.",
          avatar: require("@/assets/mt-fuji-hoei.jpg"),
        },
      ],
      templeFlights: [],
      formData: {
        name: "",
        email: "",
        organization: "",
        message: "",
        type: "temples",
        createdAt: new Date(),
      },
      isSignUpModalOpen: false,
      isLoginModalOpen: false,
      errorMessage: "",
    };
  },
  computed: {
    isUserAuthenticated() {
      const sessionStore = useSessionStore();
      return sessionStore.userId !== null;
    },
    currentTime() {
      const now = new Date();
      const options = { hour: "numeric", minute: "numeric", hour12: true };
      const localTime = new Intl.DateTimeFormat("en-US", options).format(now);

      // Get the GMT offset
      const gmtOffset = -now.getTimezoneOffset() / 60; // Convert to hours
      const gmtSign = gmtOffset >= 0 ? "+" : "-";
      const gmtHours = Math.abs(gmtOffset).toString().padStart(2, "0");

      return `${localTime} GMT${gmtSign}${gmtHours}:00`;
    },
  },
  methods: {
    navigateToPartners() {
      this.$router.push("/partners");
    },
    scrollToBookDarshan() {
      const templeFlightsSection = document.getElementById("temple-flights");
      const contactFormSection = document.getElementById("contact-form");

      // Scroll to temple flights first, fallback to contact form
      if (templeFlightsSection) {
        templeFlightsSection.scrollIntoView({ behavior: "smooth" });
      } else if (contactFormSection) {
        contactFormSection.scrollIntoView({ behavior: "smooth" });
      }
    },
    getTruncatedDescription(description, maxLength) {
      return truncateText(description, maxLength);
    },
    navigateToListing(listingId) {
      this.$router.push({
        path: `/listing`,
        query: { listingId: listingId },
      });
    },
    fetchTempleFlights() {
      const db = getFirestore();
      const templeFlightsQuery = query(
        collection(db, "listings"),
        orderBy("createdAt", "desc")
      );

      this.unsubscribe = onSnapshot(templeFlightsQuery, (snapshot) => {
        const temples = snapshot.docs.map((doc) => {
          return {
            id: doc.id,
            ...doc.data(),
          };
        });

        this.templeFlights = temples.map((temple) => {
          return {
            ...temple,
            pricePerGuest: 49,
            eventDate: temple.createdAt.toDate().toLocaleDateString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
            }),
            eventTime: temple.createdAt.toDate().toLocaleTimeString(),
            endDate: new Date(temple.endDate).toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
            }),
          };
        });
      });
    },
    submitForm() {
      const db = getFirestore();
      const formCollection = collection(db, "inquiries");

      addDoc(formCollection, this.formData)
        .then(() => {
          console.log("Form data submitted successfully!");
          this.formData = {
            name: "",
            email: "",
            organization: "",
            message: "",
            type: "temples",
            createdAt: new Date(),
          };
        })
        .catch((error) => {
          console.error("Error submitting form data: ", error);
        });
    },
    login() {
      amplitude.track("Login from Temples", {
        type: "Temples to Login",
      });
      this.$router.push("/login");
    },
    logout() {
      signOut(auth)
        .then(() => {
          const sessionStore = useSessionStore();
          sessionStore.clearUser();
          this.$router.push("/");
        })
        .catch(() => {
          this.$router.push("/");
        });
    },
    handleLoginSelection() {
      this.openLoginModal();
    },
    handleSignUpSelection() {
      this.openSignUpModal();
    },
    openLoginModal() {
      this.isLoginModalOpen = true;
    },
    closeLoginModal() {
      this.isLoginModalOpen = false;
      this.errorMessage = "";
    },
    openSignUpModal() {
      this.isSignUpModalOpen = true;
    },
    closeSignUpModal() {
      this.isSignUpModalOpen = false;
      this.errorMessage = "";
    },
    async handleLoginButton(data) {
      amplitude.track("Login Form Submitted", {
        type: "login",
        source: "temples_page",
        email_domain: data.email.split("@")[1] || "unknown",
        timestamp: new Date().toISOString(),
      });

      this.errorMessage = "";

      try {
        const user = await loginService.loginUser(data.email, data.password);
        const sessionStore = useSessionStore();
        sessionStore.setUserId(user.uid);

        amplitude.track("Login Success", {
          userId: user.uid,
          email: user.email,
          source: "temples_page",
          timestamp: new Date().toISOString(),
        });

        this.closeLoginModal();
      } catch (error) {
        this.errorMessage = error.message;

        let errorType = "unknown";
        if (error.message.includes("password")) {
          errorType = "wrong_password";
        } else if (error.message.includes("No account")) {
          errorType = "user_not_found";
        } else if (error.message.includes("network")) {
          errorType = "network_error";
        } else if (error.message.includes("Too many failed")) {
          errorType = "too_many_attempts";
        }

        amplitude.track("Login Failed", {
          error_type: errorType,
          error_message: error.message,
          source: "temples_page",
          timestamp: new Date().toISOString(),
        });
      }
    },
    async handleSignUp(data) {
      this.errorMessage = "";

      amplitude.track("SignUp Form Submitted", {
        type: "signUp",
        source: "temples_page",
        timestamp: new Date().toISOString(),
      });

      try {
        const user = await userAuth.signUpUser(
          data.username,
          data.email,
          data.password,
          data.confirmPassword
        );
        const sessionStore = useSessionStore();
        sessionStore.setUserId(user.uid);

        amplitude.track("SignUp Success", {
          userId: user.uid,
          email: user.email,
          displayName: user.displayName || data.username,
          source: "temples_page",
          timestamp: new Date().toISOString(),
        });

        this.closeSignUpModal();
      } catch (error) {
        this.errorMessage = error.message;

        let errorType = "unknown_error";
        if (error.message.includes("already in use")) {
          errorType = "email_already_in_use";
        } else if (error.message.includes("Invalid email")) {
          errorType = "invalid_email";
        } else if (error.message.includes("weak")) {
          errorType = "weak_password";
        } else if (error.message.includes("network")) {
          errorType = "network_error";
        } else if (error.message.includes("match")) {
          errorType = "passwords_dont_match";
        } else if (error.message.includes("fill in all")) {
          errorType = "missing_fields";
        } else if (error.message.includes("disabled")) {
          errorType = "account_disabled";
        }

        amplitude.track("SignUp Failed", {
          errorCode: error.code || "unknown_error",
          errorType: errorType,
          errorMessage: error.message,
          source: "temples_page",
          timestamp: new Date().toISOString(),
        });
      }
    },
  },
  mounted() {
    const sessionStore = useSessionStore();
    this.fetchTempleFlights();
    auth.onAuthStateChanged((user) => {
      if (user) {
        sessionStore.userId = user.uid;
      } else {
        sessionStore.userId = null;
      }
    });
  },
  setup() {
    const mainContentClass = computed(() => {
      return isMobile() ? "mobile-main-content" : "web-main-content";
    });
    const headerClass = computed(() => {
      return isMobile() ? "mobile-header" : "web-header";
    });

    return {
      mainContentClass,
      headerClass,
    };
  },
};
</script>

<style scoped>
/* General Styles */
.step-list {
  list-style-type: none;
  padding-left: 0;
  margin-bottom: 1rem;
}

.step-list-item {
  margin-bottom: 1rem;
  color: #7e7e7e;
}

.step-list-item strong {
  color: #000;
  font-size: 1.5rem;
  font-weight: 400;
}

.nested-list {
  list-style-type: disc;
  padding-left: 1.5rem;
  margin-top: 0.5rem;
}

.step-item-label {
  font-weight: bold;
  color: #aaa;
  font-size: 14px;
  margin-bottom: 1rem;
}

code {
  background-color: #2d2d2d;
  padding: 0.2rem 0.5rem;
  border-radius: 5px;
  color: #000;
}

/* Container and layout */
.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: var(--background-color);
  color: var(--text-color);
}

/* Main Content */
.mobile-main-content {
  margin-top: 20px;
  padding: 20px;
}

.web-main-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.title-container {
  margin-top: 5rem;
  position: relative;
  margin-bottom: 1rem;
}

.banner {
  width: 100%;
  height: 92vh;
  object-fit: cover;
}

.small-banner {
  width: 100%;
  height: 10vh;
  object-fit: contain;
}

.flightportal {
  width: 100%;
  height: 90vh;
  object-fit: contain;
  border-radius: 12px;
  margin-bottom: 5rem;
}

.divider {
  border-bottom: 1px solid #2d2d2d;
}

.main-title {
  font-size: 3rem;
  color: #000;
}

.main-subheading {
  font-size: 1rem;
  margin: 0 2rem;
  color: #464646;
  text-align: center;
  margin-bottom: 3rem;
}

.avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
}

.overlay-container {
  position: absolute;
  top: 20%;
  left: 10%;
  transform: translateY(0);
  border-radius: 12px;
  width: 80%;
  padding: 2rem;
  text-align: left;
  color: white;
}

.overlay-title {
  font-size: 5rem;
  margin-bottom: 0.5rem;
}

.overlay-subheading {
  font-size: 2rem;
  margin-bottom: 1rem;
  color: #f2f5f9;
}

.overlay-time-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
}

.overlay-time {
  font-size: 1rem;
  color: #e6e4e4;
}

.overlay-description-container {
  margin-top: 1rem;
  width: 40%;
  line-height: 1.4rem;
}

.overlay-description {
  font-size: 1rem;
  margin-bottom: 1.5rem;
  color: "white";
}

.overlay-input {
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 200px;
  margin-bottom: 1rem;
}

.overlay-button {
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 150px;
  height: 50px;
  border: 1px solid #e5e7eb !important;
  border-radius: 25px;
  cursor: pointer;
  padding: 10px;
  outline: none;
  font-weight: 600;
  transition: background-color 0.3s ease;
}

.overlay-button:hover {
  background-color: #e6e4e4;
}

.overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  text-align: center;
  font-size: 5rem;
  width: 60%;
}

.flightportal {
  width: 100%;
  height: 60vh;
  object-fit: contain;
  border-radius: 12px;
  margin-bottom: 5rem;
}

.how-it-works-container {
  display: flex;
  justify-content: space-between;
  margin: 0 5rem;
  margin-bottom: 10rem;
  flex-wrap: wrap;
}

.vision-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin: 10rem 0rem;
}

.vision-cards {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  margin-bottom: 2rem;
  gap: 1rem;
}

.vision-card {
  border-radius: 8px;
  width: 350px;
  align-items: left;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.vision-card h2 {
  font-size: 2rem;
  color: #222;
  text-align: left;
  margin: 0.5rem 0;
}

.vision-card h3 {
  font-size: 1.5rem;
  color: #222;
  text-align: left;
  margin: 0.5rem 0;
}

.vision-card p {
  font-size: 1rem;
  color: #7e7e7e;
  text-align: left;
  line-height: 1.3rem;
}

.vision-card span {
  color: #000;
}

.vision-card span:hover {
  text-decoration: underline;
}

.learn-more {
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
  display: flex;
  cursor: pointer;
}

.card-image {
  width: 100%;
  height: 400px;
  object-fit: cover;
  border-radius: 8px;
}

.card-image1 {
  width: 100%;
  height: 380px;
  object-fit: contain;
  border-radius: 8px;
}

.step-description,
.step-title {
  color: #000;
}

.chip {
  display: inline-block;
  padding: 5px 10px;
  font-size: 0.8rem;
  color: white;
  background-color: #2d2d2d;
  border-radius: 12px;
  margin-top: 5px;
  margin-right: 5px;
}

.date {
  font-size: 1rem;
  color: gray;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.step-container {
  margin: 0 10rem;
  flex: 1;
  display: flex;
}

.step-title {
  font-size: 2rem;
  color: #000;
  margin-bottom: 1rem;
}

.sub-step-title {
  font-size: 1.5rem;
  color: #000;
  margin-bottom: 0.5rem;
  margin-top: 1rem;
}

.step-description {
  font-size: 1rem;
  line-height: 1.6;
  color: #000;
}

.benefits-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 2rem 0;
  margin-bottom: 10rem;
}

.benefit-cards {
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.benefit-card {
  border-radius: 8px;
  padding: 1rem;
  text-align: center;
  width: 15%;
  height: 200px;
}

.benefit-card h3 {
  font-size: 1.5rem;
  color: #222;
  text-align: center;
  margin-bottom: 0.5rem;
}

.benefit-card p {
  font-size: 0.9rem;
  color: #7e7e7e;
  text-align: center;
}

.benefit-icon {
  margin-top: 1rem;
  font-size: 2rem;
}

.sustainable-goals-section {
  text-align: center;
  margin-bottom: 10rem;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
  padding: 3rem 5rem;
  margin-bottom: 10rem;
  width: 100%;
}

.grid-item {
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
}

.grid-item:hover {
}

.grid-item.disabled {
}

.flight-content {
  display: flex;
  max-height: 250px;
  flex-direction: row;
}

.image-container {
  position: relative;
}

.flight-image {
  width: 300px;
  height: 250px;
  border-radius: 8px;
  object-fit: cover;
}

.chip {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #fff;
  color: #000;
  padding: 5px 10px;
  border-radius: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  font-size: 0.8rem;
  font-weight: 500;
}

.flight-details {
  flex: 1;
  padding: 0 20px;
  display: flex;
  max-width: 300px;
  justify-content: space-between;
  flex-direction: column;
}

.flight-details h4 {
  font-size: 0.8rem;
  color: #666;
  margin-bottom: 5px;
}

.flight-details h2 {
  font-size: 1.5rem;
  color: #333;
}

.flight-details p {
  font-size: 0.8rem;
  color: #666;
}

.flight-header {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-bottom: 1rem;
}

.flight-info {
  display: flex;
  flex: 2.5;
  flex-direction: column;
  justify-content: space-between;
}

.flight-footer {
  display: flex;
  flex: 0.5;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
}

.flight-footer p {
  font-size: 1rem;
  color: #000 !important;
}

.flight-footer span {
  font-size: 0.8rem;
  color: #949494;
}

.price-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
}

.line-divider {
  border: none;
  border-top: 1px solid #e6e4e4;
}

.line-divider-light {
  border: none;
  border-top: 0.1px solid #ccc;
}

.testimonial {
  font-style: italic;
  color: #a8a8a8;
  border-left: 4px solid #2d2d2d;
  padding-left: 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.contact-form {
  display: flex;
  flex-direction: column;
}

.contact-form div {
  margin-bottom: 1rem;
}

.contact-form label {
  margin-bottom: 0.5rem;
  font-weight: bold;
  color: #000;
}

.contact-form input,
.contact-form textarea {
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
}

.contact-form button {
  background-color: #1565c0;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.5rem;
  cursor: pointer;
}

.learn-more-link {
  color: #000;
  text-decoration: underline;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
  font-weight: 500;
}
.why-drone-section {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: auto;
  gap: 2.5rem 2rem;
  max-width: 1100px;
  margin: 3rem auto 5rem auto;
  padding: 0 2rem;
  box-sizing: border-box;
  width: 100%;
}
.why-drone-section .vision-card {
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
}
@media (max-width: 900px) {
  .why-drone-section {
    grid-template-columns: 1fr;
    gap: 2rem 0;
    padding: 0 1rem;
  }
}
</style>
